import { apiClient } from '@/api/client';
import { ENDPOINTS } from '@/api/endpoints';
import { SearchCleanersDto } from '@/api/requests/DTOS';

export const searchCleaners = async (searchData: SearchCleanersDto) => {
  const searchParams = new URLSearchParams(
    Object.fromEntries(
      Object.entries(searchData).map(([key, value]: [string, unknown]) => [
        key,
        `${value}`,
      ]),
    ),
  );
  return await apiClient.get(
    `${ENDPOINTS.CLEANERS}?${searchParams.toString()}`,
  );
};
